export const VIBROSONG_PATTENS = {
    // Queen — Another One Bites the Dust
    // Ритм: парапам (пауза) пам (пауза) пам, [пауза] папампа (пауза) парарам
    'queen-dust': [
        { mode: 'heavy', duration: 500 }, 
        { mode: 'heavy', duration: 500 }, 
        { mode: 'heavy', duration: 875 }, 
        { mode: 'heavy', duration: 125 }, 
        { mode: 'heavy', duration: 250 }, 
        { mode: 'heavy', duration: 250 }, 
        { mode: 'heavy', duration: 250 }, 
        { mode: 'heavy', duration: 125 }, 
        { mode: 'heavy', duration: 250 }
        // парапам
        // { mode: 'light', duration: 100 }, 
        // { mode: 'light', duration: 100 },
        // { mode: 'medium', duration: 300 }, 
        
        // // пам
        // { mode: 'medium', duration: 300 },
        
        // // пам
        // { mode: 'heavy', duration: 450 }, 
        
        // // папампа
        // { mode: 'light', duration: 100 },
        // { mode: 'light', duration: 100 },
        // { mode: 'medium', duration: 150 },
        
        // // парарам
        // { mode: 'light', duration: 100 },
        // { mode: 'light', duration: 100 },
        // { mode: 'heavy', duration: 0 }
    ],

    // Shave and a Haircut (Классический стук в дверь: Там-та-та-там-там... там-там!)
    // Очень узнаваемый ритм для интерфейса
    'knock-knock': [
        { mode: 'medium', duration: 250 },
        { mode: 'light', duration: 125 },
        { mode: 'light', duration: 125 },
        { mode: 'medium', duration: 250 },
        { mode: 'medium', duration: 500 }, // пауза побольше
        { mode: 'medium', duration: 125 },
        { mode: 'heavy', duration: 0 }
    ],
    'seven-nation': [
        { mode: 'heavy', duration: 400 },  // Тааа (Ми)
        { mode: 'light', duration: 250 },   // ам (Ми)
        { mode: 'medium', duration: 200 },  // та (Соль)
        { mode: 'light', duration: 200 },   // та (Ми)
        { mode: 'light', duration: 200 },   // та (Ре)
        { mode: 'heavy', duration: 400 },  // Тааа (До)
        { mode: 'heavy', duration: 0 }     // Ам (Си)
    ],
    'eye-tiger': [
        { mode: 'heavy', duration: 600 },  // ТА! (Пауза)
        
        { mode: 'medium', duration: 150 }, // та
        { mode: 'light', duration: 150 },  // та
        { mode: 'heavy', duration: 600 },  // ТА! (Пауза)
        
        { mode: 'medium', duration: 150 }, // та
        { mode: 'light', duration: 150 },  // та
        { mode: 'heavy', duration: 600 },  // ТА! (Пауза)
        
        { mode: 'medium', duration: 150 }, // та
        { mode: 'heavy', duration: 0 }     // ТАА!
    ]
}